export default (value) =>{
    let val = (value/1).toFixed(2).replace(',', '.')
    return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    // return '$' + parseFloat(value).toFixed(2);
}

